import { PUBLIC_IMAGES } from '../../../config';

export enum WhatToSeeCardTypes {
  Arboretum,
  GreenhouseExposition,
  Greenhouses,
  Expositions,
  HistoricalMonumentsArtObjects,
}

export interface IWhatToSeeCardData {
  cardKey: WhatToSeeCardTypes;
  titleKey: string;
  image: string;
  page_slug?: string | null;
}

export const whatToSeeCardsData: IWhatToSeeCardData[] = [
  {
    cardKey: WhatToSeeCardTypes.Arboretum,
    titleKey: 'what-to-see.section-titles.arboretum',
    image: PUBLIC_IMAGES.ARBORETUM,
  },
  {
    cardKey: WhatToSeeCardTypes.GreenhouseExposition,
    titleKey: 'what-to-see.section-titles.greenhouse-exposition',
    image: PUBLIC_IMAGES.GREENHOUSE_EXPO,
  },
  {
    cardKey: WhatToSeeCardTypes.Greenhouses,
    titleKey: 'what-to-see.section-titles.greenhouses',
    image: PUBLIC_IMAGES.GREENHOUSE,
  },
  {
    cardKey: WhatToSeeCardTypes.Expositions,
    titleKey: 'what-to-see.section-titles.expositions',
    image: PUBLIC_IMAGES.EXPOSITIONS,
  },
  {
    cardKey: WhatToSeeCardTypes.HistoricalMonumentsArtObjects,
    titleKey: 'what-to-see.section-titles.historical-monuments-and-art-objects',
    image: PUBLIC_IMAGES.HISTORICAL_MONUMENTS,
  },
];

export const FIRST_LINE_KEYS: WhatToSeeCardTypes[] = [
  WhatToSeeCardTypes.Arboretum,
  WhatToSeeCardTypes.GreenhouseExposition,
];
